module.exports = __webpack_public_path__ + "static/media/checkmark-circle.f2fd1906.svg";